import './utils/wdyr'

// Configure regeneratorRuntime first, so we don't error out
import './runtimeConfig'
import './rn-compatibility'
import 'core-js/stable'
import 'pwacompat'

import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './components/App'
import { FeatureFlagsBoundary } from './flags'

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <FeatureFlagsBoundary>
    <App />
  </FeatureFlagsBoundary>
)
